import React, { FC } from 'react';
import styles from './innerheader.module.css';
import './header-bugger.scss';
import { NavLink } from 'react-router-dom';

const mainDomain =
  process.env.REACT_APP_GROUP_URL || 'https://www.ohyagroup.com';

export const NotFoundHeader: FC = () => {
  return (
    <>
      <div className={`max-w-[1920px] mx-auto ${styles.frame} z-10 bugger`}>
        <div></div>
        <NavLink to={mainDomain + '/'}>
          <img
            className={styles.logo}
            alt="Element"
            src="/assets/images/pages/2-5-3-4.svg"
          />
        </NavLink>
        <div></div>
      </div>
    </>
  );
};
